import './modify_order.scss';

export const ModifyOrderComponent = {
    template: `
        <div ng-if="$ctrl.cartDisplay.enableOO">
            <dining-option></dining-option>

            <order-date-time>
                <prepend-if-times-available>
                    <p class="text-left" ng-if="$ctrl.cartDisplay.diningOption === 'DELIVERY'">Where are you located?</p>
                    <location-picker ng-if="$ctrl.cartDisplay.diningOption === 'DELIVERY'"></location-picker>

                    <p class="text-left" ng-if="$ctrl.cartDisplay.restaurantAvailable && $ctrl.cartDisplay.enableScheduling">When do you want your order?</p>
                </prepend-if-times-available>
                <append-if-times-available>
                    <order-info class="form-spacing" ng-if="$ctrl.cartDisplay.restaurantAvailable && $ctrl.cartDisplay.fulfillmentType === 'ASAP'
                        && (!$ctrl.cartDisplay.message || !$ctrl.cartDisplay.message.includes('Sorry, orders will be accepted starting'))" ng-cloak></order-info>

                    <div ng-if="$ctrl.cartDisplay.message" class="form-spacing fold-animation">
                        <span class="text-warning">{{$ctrl.cartDisplay.message}}</span>
                    </div>
                </append-if-times-available>
            </order-date-time>
        </div>
    `,
    controller: class {
        constructor(cartDisplayService) {
            'ngInject';

            Object.assign(this, { cartDisplayService });

            this.cartDisplay = cartDisplayService.displayData;
        }
    }
};
